// Meoks: koleksiyon filtre alanindaki "Availability" / "Mevcudiyet" filtresini gizle
(function () {
  var KEYWORDS = ['availability', 'mevcudiyet', 'durumu', 'stok durumu', 'price', 'fiyat'];
  function hide() {
    var labels = document.querySelectorAll('.facets__label, .facets__summary .facets__label, summary .facets__label');
    for (var i = 0; i < labels.length; i++) {
      var txt = (labels[i].textContent || '').trim().toLowerCase();
      if (KEYWORDS.some(function (k) { return txt === k || txt.indexOf(k) === 0; })) {
        var container = labels[i].closest('details, .facets__disclosure, .facets__panel, .facets-pill, .facets__summary');
        if (container) container.style.display = 'none';
        else labels[i].style.display = 'none';
      }
    }
  }
  // Cache'lenmis "Diger" butonunu hemen "Filtre" ye cevir
  function relabelMore() {
    var btns = document.querySelectorAll('[aria-haspopup="dialog"].button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.querySelector('.meoks-filters-more-button__label')) continue;
      var t = (b.textContent || '').trim();
      if (t === 'Diğer' || t === 'Diger' || t === 'More' || t === '') {
        b.className = (b.className + ' meoks-filters-more-button').trim();
        b.innerHTML = '<span class="meoks-filters-more-button__label">Filtre</span>'
          + '<svg class="meoks-filters-more-button__chevron" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      }
    }
  }
  function runAll() { hide(); relabelMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();
  // Filtreler dinamik yenilenebiliyor (results-list) — debounced observer
  var t = null;
  var target = document.querySelector('.facets, results-list, main') || document.body;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(runAll, 80);
  }).observe(target, { childList: true, subtree: true });
})();
